// src/belediye/components/BelediyeLayout.js
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import BelediyeNavbar, { detayRotasiMi } from "./BelediyeNavbar";
import BelediyeSidebar from "./BelediyeSidebar";
import NotificationToaster from "./notifications/NotificationToaster";
// FAZ-87: tablette ray itmeli çalışır — içerik hangi katmanda olduğunu bilmeli.
import useKatman from "../hooks/useKatman";
// FAZ-93: kaydırınca gizlenen navbar
import useNavbarGizle from "../hooks/useNavbarGizle";
// FAZ-102: rota değişince kaydırma kabı tepeye döner
import useTepeyeDon from "../hooks/useTepeyeDon";
// FAZ-88: detay sayfası → navbar başlığı köprüsü
import { NavbarBaslikSaglayici } from "./NavbarBaslikContext";
import "./BelediyeLayout.css";

const BelediyeLayout = ({ children, user, unitName, unitSlug }) => {
  const isSahaPersoneli = user?.role === "saha_personeli";

  /* ------------------------------------------------------------
     SIDEBAR EXPANDED STATE (Desktop için)
     Mobile’da overlay davranışı Sidebar içinde kontrol edilecek.
  ------------------------------------------------------------ */
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarExpanded((prev) => !prev);
  };

  /* ------------------------------------------------------------
     FAZ-52 — SIDEBAR DURUMUNU BODY'YE YAZ
     Neden: sohbet penceresi tam ekranda sidebar'ın sağına yaslanıyor ama
     `document.body`'ye portal'landığı için sidebar durumunu React ağacından
     göremiyor. Eskiden genişliği ResizeObserver ile ÖLÇÜYORDU; rota değişince
     `.sidebar` düğümü yenilenip observer boşta kalıyor, sidebar açılıp
     kapanınca ölçüm donuyordu → pencere yanlış yerde kalıyordu.
     Çözüm: ölçüm YOK. Durum body'ye sınıf olarak yazılır, hizalamayı CSS yapar.
  ------------------------------------------------------------ */
  useEffect(() => {
    const body = document.body;
    const sidebarVar = isSahaPersoneli
      ? "0px"
      : isSidebarExpanded
      ? "var(--sidebar-expanded)"
      : "var(--sidebar-collapsed)";
    body.style.setProperty("--md-sidebar-w", sidebarVar);
    return () => body.style.removeProperty("--md-sidebar-w");
  }, [isSidebarExpanded, isSahaPersoneli]);

  /* ------------------------------------------------------------
     FAZ-98 / T-4 — TABLETTE RAY ARTIK İTMEZ, ÜSTE BİNER
     FAZ-87'nin `sidebar-genis` sınıfı (ray genişleyince içeriği daraltan)
     kaldırıldı; kullanıcı kararı için bkz. BelediyeLayout.css tablet bloğu.
     data-katman teşhis içindir — DOM'a bakınca hangi katmanda olunduğu
     görülür (FAZ-80'deki data-nobet deseninin aynısı).
  ------------------------------------------------------------ */
  const katmanAdi = useKatman();
  const kokSinif = "layout-root";

  /* ------------------------------------------------------------
     FAZ-93 madde 4 — KAYDIRINCA GİZLENEN NAVBAR
     Detay sayfalarında KAPALI (K-3): orada navbar geri okunu taşıyor;
     kaybolması çıkış yolunu gizlerdi. Liste sayfasında böyle bir yük yok.

     FAZ-98 / T-2 — YALNIZ TELEFON. Kullanıcı (2026-08-02): "bu tür sayfalarda
     sayfa kayınca navbar kayıyor. Navbar'ın kayışını mobilde yapacağız dedik;
     burada navbar kayınca çok saçma bir görüntü oluyor. Bu ekranda navbar'ın
     kaymasına gerek yok, zaten altta alt navbar yok bu yüzden."

     Kural aslında baştan buydu, uygulama sapmıştı: navbarın kaybolması
     KATLANILABİLİR çünkü telefonda gezinme alt barda DURMAYA devam ediyor.
     Tablette alt bar yok (AltBar.js:181) — navbar gidince ekranda gezinme
     adına yalnız 72px'lik ray kalıyordu. Masaüstünde de kapalıydı; tablet
     yanlış tarafta duruyordu.
  ------------------------------------------------------------ */
  const icerikRef = useRef(null);
  const { pathname } = useLocation();
  useNavbarGizle(
    icerikRef,
    katmanAdi === "telefon" && !detayRotasiMi(pathname),
  );

  /* FAZ-102 — YENİ SAYFA EN ÜSTTEN AÇILIR.
     Kaydıran şey `window` değil bu `<main>`; rota değişince düğüm SÖKÜLMEDİĞİ
     için `scrollTop` olduğu yerde kalıyor ve yeni sayfa ortasından açılıyordu.
     Ayrıntı ve neden `useLayoutEffect` için: hooks/useTepeyeDon.js */
  useTepeyeDon(icerikRef, pathname);

  return (
    /* FAZ-88 — sağlayıcı navbar'ı VE sayfayı birlikte sarmalı: detay sayfası
       başlığı yazar, navbar okur. İkisi ayrı ağaçta olsaydı köprü kurulmazdı. */
    <NavbarBaslikSaglayici>
    <div className={kokSinif} data-katman={katmanAdi}>
      {/* Sağ-üst bildirim toast katmanı (panel geneli tek mount) */}
      <NotificationToaster />

      {/* --------------------------------------------------------
         NAVBAR (Her rolde görünüyor)
      -------------------------------------------------------- */}
      <BelediyeNavbar
        user={user}
        unitName={unitName}
        unitSlug={unitSlug}
        onSidebarToggle={handleSidebarToggle}
        sidebarEnabled={!isSahaPersoneli}
        sidebarExpanded={isSidebarExpanded}
      />

      <div className="layout-body">
        {/* --------------------------------------------------------
           SIDEBAR (Saha personeli görmez)
        -------------------------------------------------------- */}
        {!isSahaPersoneli && (
          <BelediyeSidebar
            user={user}
            unitSlug={unitSlug}
            isExpanded={isSidebarExpanded}
            onToggle={handleSidebarToggle}
          />
        )}

        {/* --------------------------------------------------------
           ANA İÇERİK ALANI
           Desktop: Sidebar expanded → içerik sağa kayar
           Mobile:  Sidebar drawer → içerik kaymaz
        -------------------------------------------------------- */}
        <main
          ref={icerikRef}
          className={[
            "layout-content",
            !isSahaPersoneli && isSidebarExpanded ? "sidebar-expanded" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <div className="layout-content-inner">{children}</div>
        </main>
      </div>
    </div>
    </NavbarBaslikSaglayici>
  );
};

export default BelediyeLayout;
